import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavIconAdministration = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 14 14",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.9375 3.9375V5.25H9.3125V3.9375C9.3125 2.72891 8.33359 1.75 7.125 1.75C5.91641 1.75 4.9375 2.72891 4.9375 3.9375ZM3.1875 5.25V3.9375C3.1875 1.76367 4.95117 0 7.125 0C9.29883 0 11.0625 1.76367 11.0625 3.9375V5.25H11.5C12.4652 5.25 13.25 6.03477 13.25 7V12.25C13.25 13.2152 12.4652 14 11.5 14H2.75C1.78477 14 1 13.2152 1 12.25V7C1 6.03477 1.78477 5.25 2.75 5.25H3.1875Z",
		fill: "currentColor"
	})
});
export default SvgNavIconAdministration;
